import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyReturnKey,
  ShopifyReturnShippingFeeKey,
  ShopifyReturnShippingFeeToReturnKey,
  ShopifyReturnShippingFeeToShopKey,
  ShopifyShopKey,
} from "./keys";
import type { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

export const returnShippingFeeMoneySelection = "shopMoney { amount currencyCode } presentmentMoney { amount currencyCode }";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyReturnShippingFeeKey,
  "2024-07": {
    name: "Shopify Return Shipping Fee",
    graphQLTypename: "ReturnShippingFee",
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id", graphQLFieldKey: "id" } },
      },
      {
        name: "Amount Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "amountSet",
            graphQLFieldKey: "amountSet",
            graphQLSelection: `
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          `,
          },
        },
      },
      {
        name: "Return",
        fieldType: FieldType.BelongsTo,
        key: ShopifyReturnShippingFeeToReturnKey,
        configuration: {
          relatedModelKey: ShopifyReturnKey,
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyReturnShippingFeeToShopKey,
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: {
      type: "inherit",
    },
  },
  "2025-04": {
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "id",
            graphQLFieldKey: "id",
            availableInWebhook: ["returns/approve"],
          },
        },
      },
      {
        name: "Amount Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "amountSet",
            graphQLFieldKey: "amountSet",
            graphQLSelection: `
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          `,
          },
        },
      },
    ],
    syncConfig: {
      type: "inherit",
    },
  },
  "2026-10": {
    fields: [
      {
        name: "Finalized Tax Amount Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "finalizedTaxAmountSet",
            graphQLSelection: returnShippingFeeMoneySelection,
            graphQLOnlyField: true,
          },
        },
      },
    ],
  },
};

export const ShopifyReturnShippingFee = ({
  apiVersion,
  frameworkVersionConstraint,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint: string;
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint);
